enum CustomImportTypeEnum {
    BULK_ORDERS = "Bulk Orders",
    ORDER = "Order",
    ACCOUNTS = "Accounts",
}

export default CustomImportTypeEnum;
